import { render, staticRenderFns } from "./ShirtsReport.vue?vue&type=template&id=a5981414&scoped=true&"
import script from "./ShirtsReport.vue?vue&type=script&lang=js&"
export * from "./ShirtsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5981414",
  null
  
)

export default component.exports